import type { FormField } from '@cli-types/core-engine/schema.js'

export function textareaClass(height?: FormField['height']): string {
  const base =
    'min-h-24 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs outline-none transition-[color,box-shadow] placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50'
  return height === 'fill' ? `${base} flex-1` : base
}
